export default "__VITE_ASSET__BM58tHlk__"